<template>
  <b-container fluid>
    <div id="module-form">
      <b-row v-if="isAdmin || isSRC">
        <b-col cols="6">
          <b-form-group class="mt-2">
            <br />
            <br />
            <label for="module_date">Workshop Date:</label>
            <b-form-input
              name="module_date"
              type="date"
              id="date"
              v-model="dateForm"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="guest-speaker">Guest Speaker:</label>
            <br />
            <b-form-input
              v-model="guestSpeaker"
              name="guest-speaker"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="workshop-discussion">Workshop Discussion:</label>
            <br />
            <b-form-textarea
              rows="3"
              max-rows="6"
              v-model="toDo"
              name="to-do"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="to-do">To Do:</label>
            <br />
            <b-form-textarea
              rows="3"
              max-rows="6"
              v-model="previousWorkshopFeedback"
              name="workshop-feedback"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="workshop-feedback">Workshop Feedback:</label>
            <br />
            <b-form-textarea
              rows="3"
              max-rows="6"
              v-model="changesMade"
              name="changes-made"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="changes-made">Changes Made:</label>
            <br />
            <b-form-textarea
              rows="3"
              max-rows="6"
              v-model="todayDiscussion"
              name="workshop-discussion"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="next-venue">Next Workshop Venue:</label>
            <br />
            <b-form-input v-model="nextVenue" name="next-venue"></b-form-input>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="next-date">Next Workshop Date:</label>
            <br />
            <b-form-input
              type="date"
              v-model="nextDate"
              name="next-date"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="next-time">Next Workshop Time:</label>
            <br />
            <b-form-input
              type="time"
              v-model="nextTime"
              name="next-time"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="mt-2">
            <div id="selected-Teachers">
              <label for="selected-Teachers">Teachers in Attendance:</label>
              <b-table
                v-cloak
                responsive
                :fields="teacherAttendanceFields"
                :items="teachersNames"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
              >
                <template slot="cell(delete)" slot-scope="row">
                  <b-link
                    class="delete"
                    @click.stop="deleteTeacherFromWorkshop(row.item)"
                    >DEL</b-link
                  >
                </template>
              </b-table>
            </div>
          </b-form-group>
          <b-button variant="primary" block class="mt-2" @click="addOrUpdate">
            {{ buttonTitle }}
          </b-button>
          <b-button variant="danger" block class="mt-2" @click="clearForm()"
            >Cancel</b-button
          >
        </b-col>
        <b-col>
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Teachers</h4>
            <div>
              <name-search parent="tw" table="teachers"></name-search>
            </div>
            <br />
            <b-col v-if="cleanedSearchResults.length">
              <h6 class="subtitle">
                Results: {{ getTeacherSearchResults.length }} teachers found
              </h6>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="filterSearchResults"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!filterSearchResults"
                      @click="filterSearchResults = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <div id="alerts" ref="teacher-workshop-alert">
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown = 0"
                  @dismiss-count-down="countDownChanged"
                  >You have successfully added a teacher workshop!</b-alert
                >
                <b-alert :show="showError" dismissible variant="warning">
                  Something went wrong. Please refresh and try again, or contact
                  the site admin.
                </b-alert>
              </div>
              <b-table
                v-cloak
                responsive
                :fields="searchResultsFields"
                :items="cleanedSearchResults"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(first_name)" slot-scope="row">
                  <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditTeacher', params: { id: row.item.id } }"
                    >{{ row.item.teacher_name }}</b-link
                  >
                  <br />
                  <p class="small-date">created: {{ row.item.created }}</p>
                  <p class="small-date">
                    Head Teacher?:
                    {{ row.item.head_teacher === true ? "Y" : "F" }}
                  </p>
                </template>
                <template slot="cell(sex)" slot-scope="row">
                  {{ row.item.sex === "male" ? "M" : "F" }}
                </template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link
                    class="add"
                    @click.stop="addTeacherToWorkshop(row.item)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </b-col>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="table-wrap mt-4">
            <b-table
              v-cloak
              responsive
              small
              :fields="teacherWorkshopFields"
              :items="teacherWorkshops"
              :striped="true"
              :bordered="true"
              :hover="true"
              :filter="filter"
              :current-page="currentPage"
              @filtered="onFiltered"
              :per-page="perPage"
              stacked="md"
              id="teacher-workshop-table"
            >
              <template slot="cell(edit)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="edit"
                  @click.stop="editWorkshop(row.item)"
                  >EDIT</b-link
                >
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="delete"
                  @click.stop="deleteWorkshop(row.item)"
                  >DELETE</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NameSearch from "@/components/NameSearch";
import { flash } from "@/mixins/flashes";
import { scrollTo } from "@/mixins/scrollTo";
import TrainerService from "../services/TrainerService";

export default {
  name: "TeacherSupportWorkshops",
  mixins: [flash, scrollTo],
  components: {
    NameSearch
  },
  data() {
    return {
      id: null,
      dateForm: null,
      courseForm: "",
      teachersIds: [],
      teachersNames: [],
      guestSpeaker: "",
      todayDiscussion: "",
      toDo: "",
      previousWorkshopFeedback: "",
      changesMade: "",
      nextDate: null,
      nextVenue: "",
      nextTime: "",
      schoolTeacherFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "head_teacher", label: "HT?", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" }
      ],
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" }
      ],
      teacherAttendanceFields: [
        { key: "teacher_name", label: "Teacher Name", sortable: true },
        { key: "delete", label: "DELETE" }
      ],
      teacherWorkshopFields: [
        { key: "date", label: "Workshop Date", sortable: true },
        {
          key: "teachers_count",
          label: "Teachers in Attendance",
          sortable: true
        },
        { key: "edit", label: "EDIT", sortable: true },
        { key: "delete", label: "DELETE", sortable: true }
      ],
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
      formError: false,
      changeTitle: false,
      buttonTitle: "Add Teacher Workshop"
    };
  },
  methods: {
    ...mapActions({
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
      GET_WORKSHOPS: "trainers/GET_TEACHER_WORKSHOPS"
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
    clearForm() {
      this.dateForm = null;
      this.guestSpeaker = "";
      this.teachersIds = [];
      this.teachersNames = [];
      this.todayDiscussion = "";
      this.toDo = "";
      this.previousWorkshopFeedback = "";
      this.changesMade = "";
      this.nextVenue = "";
      this.nextDate = "";
      this.nextTime = "";
    },
    addTeacherToWorkshop(row) {
      if (
        this.teachersIds.includes(row.id) ||
        this.teachersNames.includes(row.teacher_name)
      ) {
        return;
      }
      this.teachersIds.push(row.uuid);
      this.teachersNames.push({ teacher_name: row.teacher_name, id: row.uuid });
    },
    async addTeacherWorkshop() {
      if (this.dateForm && this.teachersIds.length) {
        const payload = {
          workshop_date: this.dateForm,
          trainer_uuid: this.$route.params.id,
          teachers_uuid: this.teachersIds,
          today_discussion: this.todayDiscussion,
          to_do: this.toDo,
          previous_workshop_feedback: this.previousWorkshopFeedback,
          changes_made: this.changesMade,
          next_workshop_venue: this.nextVenue,
          next_workshop_date: this.nextDate,
          next_workshop_time: this.nextTime
        };
        await TrainerService.addTrainerTeacherWorkshop(payload);
        await this.scrollTo("teacher-workshop-alert");
        await this.flashSuccess();
        this.clearForm();
        this.formError = false;
        this.changeTitle = false;
        await this.RESET_SEARCH();
        await this.GET_WORKSHOPS();
      } else {
        this.formError = true;
        this.flashError();
      }
    },
    async editWorkshop(row) {
      const workshop = await TrainerService.fetchOneTrainerTeacherWorkshop(
        row.id
      );
      const data = workshop.data.results;
      const names = data.teacher_names;
      console.log(`edit workshop: ${data}`);
      this.teachersNames = [];

      for (let i = 0; i < names.length; i++) {
        this.teachersNames.push({ teacher_name: names[i] });
      }

      this.id = data.id;
      this.dateForm = data.date;
      this.teachersIds = data.teachers_uuid;
      this.todayDiscussion = data.today_discussion;
      this.toDo = data.to_do;
      this.previousWorkshopFeedback = data.previous_workshop_feedback;
      this.changesMade = data.changes_made;
      this.nextVenue = data.next_workshop_venue;
      this.nextDate = data.next_date;
      this.nextTime = data.next_workshop_time;
      this.buttonTitle = "Edit Teacher Workshop";
    },
    async updateWorkshop(row) {
      if (this.dateForm && this.teachersIds.length) {
        const payload = {
          id: this.id,
          workshop_date: this.dateForm,
          trainer_uuid: this.$route.params.id,
          teachers_uuid: this.teachersIds,
          today_discussion: this.todayDiscussion,
          to_do: this.toDo,
          previous_workshop_feedback: this.previousWorkshopFeedback,
          changes_made: this.changesMade,
          next_workshop_venue: this.nextVenue,
          next_workshop_date: this.nextDate,
          next_workshop_time: this.nextTime
        };
        await TrainerService.updateTrainerTeacherWorkshop(payload);
        await this.scrollTo("teacher-workshop-alert");
        await this.flashSuccess();
        this.clearForm();
        this.formError = false;
        this.changeTitle = false;
        await this.RESET_SEARCH();
        await this.GET_WORKSHOPS();
      } else {
        this.formError = true;
        this.flashError();
      }
    },
    async deleteWorkshop(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this teacher workshop record?"
      );
      if (confirmDelete) {
        await TrainerService.deleteTrainerTeacherWorkshop(params);
        await this.GET_WORKSHOPS();
      }
    },
    async deleteTeacherFromWorkshop(row) {
      this.teachersIds.splice(this.teachersIds.indexOf(row.uuid), 1);
      this.teachersNames = this.teachersNames.filter(
        key => key.teacher_name !== row.teacher_name
      );
    },
    addOrUpdate() {
      if (this.buttonTitle === "Add Teacher Workshop") {
        this.addTeacherWorkshop();
      } else {
        this.updateWorkshop();
      }
    }
  },
  computed: {
    ...mapGetters({
      getTeacherSearchResults: "searches/getTeacherSearchResults",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    teacherWorkshops() {
      return this.$store.state.trainers.teachersWorkshops;
    },
    cleanedSearchResults() {
      const data = this.getTeacherSearchResults.map(k => ({
        id: k.id,
        teacher_name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        head_teacher: k.head_teacher,
        active: k.active,
        sex: k.sex,
        created: k.created
      }));
      return data;
    },
    rows() {
      if (this.teachers.length > 0) {
        return this.teachers.length;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.schoolTeacherFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    }
  },
  mounted() {
    this.RESET_SEARCH();
    this.GET_WORKSHOPS();
  }
};
</script>
